import Cookies from '@/utils/cookie-provider'
import Config from '@/config'
import { isLocalhost } from '@/utils/enviroment'

const LOCALE_KEY = 'tamara-checkout-locale'
const ENV_LIST = ['production', 'staging', 'sandbox']
/**
 * Get Cookie  attributes
 * @param {*} global
 * @param {Object} optionAttrs
 * @returns {Object}
 */
const getCookieAttributes = (global, optionAttrs = {}) => {
  const cookieAttributes = isLocalhost(global) ? {} : { secure: true }

  return { ...cookieAttributes, ...optionAttrs }
}

const getTamaraDomainCookieAttributes = (global, optionAttrs = {}) => {
  // @Todo: Remove this temp fix when all envs moved to GCP
  const domain = ENV_LIST.includes(Config.env) ? 'tamara.co' : 'tamaratech.co'
  const cookieAttributes = isLocalhost(global)
    ? { path: '/' }
    : { domain, secure: true, path: '/' }

  return { ...cookieAttributes, ...optionAttrs }
}

const setStickyLocale = (locale) => {
  Cookies.set(LOCALE_KEY, locale, getCookieAttributes(window))
}

const getStickyLocale = () => {
  return Cookies.get(LOCALE_KEY)
}

const clearStickyLocale = () => {
  return Cookies.remove(LOCALE_KEY, getCookieAttributes(window))
}

export default {
  getCookieAttributes,
  getTamaraDomainCookieAttributes,
  // Cache customer's locale
  setStickyLocale,
  getStickyLocale,
  clearStickyLocale,
}
